// Constant
import { FAKE_RESPONSE } from 'constant/shared.constant'

// Interfaces
import {
  IAboutUsWorkCultureApiGetAllResponse,
  IAboutUsWorkCultureApiGetResponse,
} from 'interfaces/back-office/content-management/about-us/work-culture/about-us-work-culture-api.interface'
// Moment
import moment from 'moment'

export const ABOUT_US_WORK_CULTURES: IAboutUsWorkCultureApiGetAllResponse = {
  ...FAKE_RESPONSE,
  res: {
    message: 'Get About Us Work Cultures Success',
    success: '1',
    data: {
      pageNumber: 1,
      itemsPerPage: 10,
      sortColumn: '',
      sortDirection: true,
      totalData: 10,
      list: [
        {
          id: 1,
          title: 'Title',
          content: [
            {
              id: 1,
              title: 'Content 1',
            },
            {
              id: 2,
              title: 'Content 2',
            },
            {
              id: 3,
              title: 'Content 3',
            },
          ],
          status: true,
          createdAt: moment().toString(),
          updatedAt: moment().toString(),
        },
        {
          id: 2,
          title: 'Title 2',
          content: [
            {
              id: 1,
              title: 'Content 1',
            },
            {
              id: 2,
              title: 'Content 2',
            },
          ],
          status: true,
          createdAt: moment().toString(),
          updatedAt: moment().toString(),
        },
      ],
    },
  },
}

export const ABOUT_US_WORK_CULTURE: IAboutUsWorkCultureApiGetResponse = {
  ...FAKE_RESPONSE,
  res: {
    message: 'Save About Us Work Culture Success',
    success: '1',
    data: {
      id: 1,
      title: 'Title',
      content: [
        {
          id: 1,
          title: 'Content 1',
        },
        {
          id: 2,
          title: 'Content 2',
        },
        {
          id: 3,
          title: 'Content 3',
        },
      ],
      status: true,
      createdAt: moment().toString(),
      updatedAt: moment().toString(),
    },
  },
}
